import { ZodSchema, z } from 'zod';

import { LlmOutputTypesEnum } from '@eluve/graphql-types';
import { stringBooleanSchema } from '@eluve/utils';

import { billingCodeSchema } from './billing-code-schema';
import { chiefComplaintSchema } from './chief-complaint.schema';
import {
  differentialDiagnosesSchema,
  differentialDiagnosisSchema,
} from './differential-diagnoses';
import { medicineRecommendationSchema } from './medicine.schema';
import { patientOverviewSchema } from './patient-overview.schema';
import { pfshSchema } from './pfsh-schema';
import { redFlagsOutputSchema } from './red-flags.schema';
import { reviewOfSystemsSchema } from './review-of-systems-schema';
import { SOAPSchema } from './soap-note';

export const factVerificationSchema = z.object({
  verdict: stringBooleanSchema,
  evidence: z.string(),
});

export const factGenerationSchema = z.object({
  diffs: z.array(
    z.object({
      category: z.enum(['ADDED', 'EDITED', 'DELETED']),
      llmNote: z.string().describe('Excerpt from the LLM note').nullable(),
      finalNote: z.string().describe('Excerpt from the final note').nullable(),
      facts: z.array(
        z.object({
          statement: z.string(),
          expectedValue: z.boolean(),
        }),
      ),
    }),
  ),
});

export const piiRemovalSchema = z.object({
  redactedText: z.string(),
  redactedFields: z.array(
    z.object({
      excerpt: z.string(),
      category: z.string(),
      explanation: z.string().optional(),
    }),
  ),
});
export const dynamicOutputSchema = z.object({}).passthrough();
export const translationSchema = z.object({
  items: z.array(z.string()),
});

export const llmOutputValidators: Record<LlmOutputTypesEnum, ZodSchema<any>> = {
  BILLING_CODE_RECOMMENDATION: billingCodeSchema,
  CHAT: z.any(),
  CHIEF_COMPLAINT: chiefComplaintSchema,
  CLIENT_RECAP: z.any(),
  DIAGNOSES_JUSTIFICATION: differentialDiagnosisSchema,
  DIFFERENTIAL_DIAGNOSES_PLUS_RED_FLAGS: redFlagsOutputSchema,
  DIFFERENTIAL_DIAGNOSES: differentialDiagnosesSchema,
  DYNAMIC_OUTPUT: dynamicOutputSchema,
  FACT_GENERATION: factGenerationSchema,
  FACT_VERIFICATION: factVerificationSchema,
  GENERIC_OUTPUT: z.any(),
  MEDICINE_RECOMMENDATION: medicineRecommendationSchema,
  PATIENT_OVERVIEW: patientOverviewSchema,
  PFSH: pfshSchema,
  PII_REMOVAL: piiRemovalSchema,
  REVIEW_OF_SYSTEMS: reviewOfSystemsSchema,
  SOAP_NOTE: SOAPSchema,
  TRANSCRIPTION: z.any(),
  TRANSLATION: translationSchema,
  PREVISIT_INSIGHTS: z.any(),
  // Task extraction output goes to FHIR Tasks, not llm_outputs — the real
  // schema lives in buildTasksExtractionSchema (@eluve/mini-apps-backend).
  TASK_EXTRACTION: z.any(),
};
